// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yDhCE","footer":"styles_footer__2ROjT","passCodeTooltip":"styles_passCodeTooltip__oSnni"};